(function () {
  'use strict';

  angular.module('app').component('creditPaymentTermList', creditPaymentTermList());

  function creditPaymentTermList() {
    return {
      bindings: {
        creditPaymentTerms: '=',
        totalItems: '=',
        loadingItems: '<',
        onShowCreditPaymentTerm: '&',
      },
      controller: CreditPaymentTermListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/credit-payment-terms/credit-payment-term-list/credit-payment-term-list.component.html',
    };
  }

  CreditPaymentTermListComponent.$inject = ['UtilService', 'CreditPaymentTermService'];

  function CreditPaymentTermListComponent(UtilService, CreditPaymentTermService) {
    var vm = this;

    // TODO: pending
    vm.permissions = {
      canCreate: true, //Ability.can('create_creditpaymentterm_accountadmin'),
      canShow: true, //Ability.can('show_creditpaymentterm_accountadmin'),
      canUpdate: true, //Ability.can('update_creditpaymentterm_accountadmin'),
      canDestroy: true, //Ability.can('destroy_creditpaymentterm_accountadmin')
    };

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.showCreditPaymentTerm = showCreditPaymentTerm;
    vm.changeCreditPaymentTermStatus = changeCreditPaymentTermStatus;
    vm.setDefaultCreditPaymentTerm = setDefaultCreditPaymentTerm;
    vm.deleteCreditPaymentTerm = deleteCreditPaymentTerm;

    function showCreditPaymentTerm(creditPaymentTerm, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowCreditPaymentTerm({ item: creditPaymentTerm, mode: mode });
    }

    function changeCreditPaymentTermStatus(creditPaymentTerm) {
      if (!vm.permissions.canUpdate || creditPaymentTerm.is_default) {
        return;
      }

      CreditPaymentTermService.changeCreditPaymentTermStatus(creditPaymentTerm);
    }

    function setDefaultCreditPaymentTerm(creditPaymentTerm) {
      var successCallback = function () {
        vm.creditPaymentTerms.forEach(function (item) {
          if (item.id !== creditPaymentTerm.id) {
            item.is_default = false;
          }
        });
      };

      CreditPaymentTermService.setDefaultCreditPaymentTerm(creditPaymentTerm, successCallback);
    }

    function deleteCreditPaymentTerm(creditPaymentTerm, index) {
      if (!vm.permissions.canDestroy || creditPaymentTerm.is_default) {
        return;
      }

      var successCallback = function (index) {
        vm.creditPaymentTerms.splice(index, 1);

        vm.totalItems = vm.creditPaymentTerms.length - 1;
      };

      CreditPaymentTermService.deleteCreditPaymentTerm(creditPaymentTerm, successCallback);
    }
  }
})();
